<template>
    <div v-if="loading" class="loading">Loading...</div>
    <div class="flex h-screen w-screen relative bg-[#74B4DF]">
        <div class="h-full w-1/4 p-6  bg-red-100 relative">
          <div class="h-full bg-red-400 rounded-lg flex flex-col">
            <div class="h-[30%]">
              <router-link :to="`/logout`">
                <div class="p-2">
                    <img class="xl:w-14 lg:w-12 md:w-10 sm:w-10 hover:border hover:ring-4 hover:rounded-lg hover:p-2" src="../assets/materials/logout.png" alt="logout">
                </div>
              </router-link>
            </div>
            <div class="relative h-3/4">
                <div class="flex justify-around items-center p-2">
                  <p class="text-4xl underline">กติกา</p>
                  <img class="xl:w-20 lg:w-20 md:w-14 sm:w-10 cursor-pointer border-4 p-1 rounded-lg" src="../assets/materials/speaker.png" alt="speaker" @click="playDescriptionStar()">
                </div>

                <div>
                  <img src="../assets/avatar/old-both.png" alt="old both">
                  <!-- <p class="p-4 xl:text-xl lg:text-lg md:text-md sm:text-sm">
                    ด่าน 1-5 หากตอบถูกตั้งแต่ครั้งแรกได้ 3 ดาว ตอบผิด 1 ครั้ง ได้ 2 ดาว ตอบผิด 2 ครั้งขึ้นไป ได้ 1 ดาว
                    ส่วนด่านที่ 6 หากท่านสามารถจับคู่ภาพได้ภายในการเปิด 20 ครั้ง ได้ 3 ดาว การเปิด 21-30 ครั้ง ได้ 2 ดาว การเปิด 31 ครั้งขึ้นไป ได้ 1 ดาว อย่าลืมเก็บดาวให้ครบนะคะ
                  </p> -->
                </div>
            </div>
          </div>            
        </div>

        <div class="flex flex-col w-full h-full">

          <div class="h-1/6 w-full flex justify-center items-center xl:p-20 lg:p-18 md:p-14 sm:p-10">
            <ul class="w-full flex justify-center p-0">
              <div class="w-full flex justify-center gap-x-4">
                <li class="w-fit">
                    <p class="cursor-pointer w-full text-center p-4 px-4 font-medium xl:text-5xl lg:text-3xl md:text-2xl sm:text-1xl rounded-3xl shadow-orange-600 shadow-lg hover:ring-4 hover:ring-orange-300" :class="$store.state.level === 'easy' ? 'bg-blue-400' : 'bg-[#FEF0C9]' " @click="$store.dispatch('setLevel', 'easy')">ระดับง่าย</p>
                </li>
                <li class="w-fit">
                    <p class="cursor-pointer w-full text-center p-4 px-4 font-medium xl:text-5xl lg:text-3xl md:text-2xl sm:text-1xl rounded-3xl shadow-orange-600 shadow-lg hover:ring-4 hover:ring-orange-300" :class="$store.state.level === 'medium' ? 'bg-blue-400' : 'bg-[#FEF0C9]' " @click="$store.dispatch('setLevel', 'medium')">ระดับปานกลาง</p>
                </li>
                <li class="w-fit">
                    <p class="cursor-pointer w-full text-center p-4 px-4 font-medium xl:text-5xl lg:text-3xl md:text-2xl sm:text-1xl rounded-3xl shadow-orange-600 shadow-lg hover:ring-4 hover:ring-orange-300" :class="$store.state.level === 'hard' ? 'bg-blue-400' : 'bg-[#FEF0C9]' " @click="$store.dispatch('setLevel', 'hard')">ระดับยาก</p>
                </li> 
              </div>               
            </ul>
          </div>

          <div class="relative flex w-full h-full p-4">
            <div class="bg-[#97C9E6] flex justify-center items-center h-full w-full rounded-3xl">

              <div v-if="checkpoints[$store.state.level]">
                <div v-for="n in 6" :key="n">                  
                  <router-link :to="`/checkpoint/${n}`">
                    <div :class="positionCustoms[n - 1]+' xl:px-20 lg:px-10 md:px-4 sm:px-2 py-4 hover:ring-[#b0b2f3] hover:ring-4 absolute rounded-3xl m-0 text-center text-white bg-[#6F70C3]'">
                      <div class="relative w-[100px] -top-[70px]">
                        <img class="absolute xl:scale-150 lg:scale-75 md:scale-75 sm:scale-50" :src="'../assets/star/'+checkpoints[$store.state.level][n-1]+'.png'" alt="star"/>
                      </div>                
                      <div class="xl:text-6xl lg:text-3xl md:text-2xl sm:text-xl">{{ n }}</div>
                    </div>
                  </router-link>

                </div>                        
              </div>
              
              <div class="flex justify-center items-center">
                <img class="xl:w-[100%] lg:w-[70%] md:w-[40%] sm:w-[40%]" src="../assets/materials/brain.png" alt="brain">
              </div>
              
            </div>
          </div>

        </div>
    </div>    
</template>

<script>
import soundDetailStar from '.././js/sound-detail-star';
import firestore from '../js/firebase';
import { getDoc, doc } from "firebase/firestore";

export default {
    name: "CheckPoint",
    props: {
        msg: String,
    },
    data () {
        return {
            user_id: this.$store.state.user_id,
            checkpoints: [],
            positionCustoms: [
              'xl:right-[430px]  xl:top-[55px]  lg:right-[250px]  lg:top-[100px]  md:right-[250px]  md:top-[10px]  sm:right-[180px]  sm:top-[30px]  ',
              'xl:left-[80px] xl:top-[70px]  lg:left-[70px] lg:top-[140px]     md:left-[110px] md:top-[30px]    sm:left-[100px] sm:top-[40px]  ',
              'xl:right-[55px] xl:top-[300px]  lg:right-[20px] lg:top-[300px]    md:right-[100px] md:top-[140px]  sm:right-[90px] sm:top-[170px] ',
              'xl:right-[105px] xl:top-[150px] lg:right-[35px] lg:top-[180px]    md:right-[110px] md:top-[50px]   sm:right-[80px] sm:top-[90px]  ',
              'xl:left-[35px]  xl:top-[240px]  lg:left-[20px]  lg:top-[270px]    md:left-[50px]  md:top-[115px]   sm:left-[60px]  sm:top-[120px] ',
              'xl:left-[180px]  xl:top-[430px] lg:left-[80px]  lg:top-[390px]    md:left-[170px]  md:top-[190px]  sm:left-[150px]  sm:top-[210px] ',
            ],
            positionCustoms_: [
              'xl:left-[470px]  xl:top-[55px]  lg:right-[250px]  lg:top-[100px]  md:right-[250px]  md:top-[10px]  sm:right-[210px]  sm:top-[40px]  ',
              'xl:right-[750px] xl:top-[70px]  lg:left-[35px] lg:top-[140px]     md:left-[110px] md:top-[30px]    sm:left-[120px] sm:top-[60px]  ',
              'xl:right-[55px] xl:top-[300px]  lg:right-[20px] lg:top-[300px]    md:right-[100px] md:top-[140px]  sm:right-[90px] sm:top-[170px] ',
              'xl:right-[105px] xl:top-[150px] lg:right-[35px] lg:top-[180px]    md:right-[110px] md:top-[50px]   sm:right-[100px] sm:top-[80px]  ',
              'xl:left-[35px]  xl:top-[240px]  lg:left-[20px]  lg:top-[270px]    md:left-[50px]  md:top-[115px]   sm:left-[80px]  sm:top-[140px] ',
              'xl:left-[180px]  xl:top-[430px] lg:left-[80px]  lg:top-[390px]    md:left-[170px]  md:top-[180px]  sm:left-[130px]  sm:top-[220px] ',
            ]
        }
    },
    created () {
      console.log(this.$store.state.user_id);
      !this.$store.state.user_id ? window.location.replace("/#/logout/") : soundDetailStar();  
      this.getDataCheckpoint();
    },
    methods: {        
        async getDataCheckpoint(){  
            
            this.checkpoints = [];

            const convertToArray = (checkpoint) => {
                const loopCheckpoint = [1,2,3,4,5,6];
                return loopCheckpoint.map((checkpoint_sequence) => {
                  return checkpoint['checkpoint_'+checkpoint_sequence];
                })
            }

            const docRef = doc(firestore, "checkpoints", this.$store.state.user_id);
            return await getDoc(docRef).then((docSnap) => {
                if (docSnap.exists()) {        
                    const checkpoints = docSnap.data();

                    const easy = convertToArray(checkpoints.easy);
                    const medium = convertToArray(checkpoints.medium);
                    const hard = convertToArray(checkpoints.hard);

                    this.checkpoints = { easy, medium, hard};  
                    this.$store.dispatch('setCheckPoint', docSnap.data())
                } else {        
                    console.log("No such document!");
                }    
            });
        },
        async playDescriptionStar() {
          soundDetailStar();
        }
    }
};
</script>